import { findNativeApp } from 'utils/findNativeApp';
import { NativeAppStatus } from 'utils/nativeApps';

import { WEAR_NATIVE_APP_ID } from '../../partnerCenterApp/constants/native-apps';

/**
 * @description Returns the URL of the org's Wear (DaVinci) app from the token
 * scope list org.
 *
 * The token's orgNativeApps carry the org-level `url` and the global
 * `nativeApp.url`, but not Helium's `determinedUrl` virtual field. For Wear the
 * org-level `url` is normally null and the real URL lives on the global native
 * app, so this applies the same precedence as `determinedUrl`: the org-level
 * `url` first, then `nativeApp.url`.
 *
 * The token's orgNativeApps include every status, so an app that is not
 * ACTIVE is treated as absent, matching Helium's SSO redirect.
 * @param org - the org from a token scope list item
 * @returns {string | undefined} The Wear URL, or undefined when the org has no
 * Wear native app, the app is not ACTIVE, or neither URL is set.
 */
export const getWearRedirectUrl = (
  org?: Utils.ArrayElement<
    Api.Response['describeAccessToken']['tokenScopeList']
  >['org'],
) => {
  if (!org) return;

  const wearNativeApp = findNativeApp(org.orgNativeApps, WEAR_NATIVE_APP_ID);
  if (wearNativeApp?.status !== NativeAppStatus.Active) return;

  return wearNativeApp?.url || wearNativeApp?.nativeApp?.url || undefined;
};
